import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GeneralOffersState {
    isLoading: boolean;
    isError: boolean;
    generalOffers: any[];
    displayedCount: number;
    hasMore: boolean;
    needMoreDataFromAlgolia: boolean
}

const initialState: GeneralOffersState = {
    isLoading: false,
    isError: false,
    generalOffers: [],
    displayedCount: 0,
    hasMore: true,
    needMoreDataFromAlgolia: false
};

export const GeneralOffersSlice = createSlice({
    name: "generalOffersSlice",
    initialState,
    reducers: {
        resetGeneralOffers: () => initialState,
        setGeneralOffers: (state, action: PayloadAction<any[]>) => {
            const newItems = action.payload.filter(newItem => 
                !state.generalOffers.some(existingItem => 
                    existingItem.objectID === newItem.objectID
                )
            );
            state.generalOffers = [...state.generalOffers, ...newItems];
            state.hasMore = state.displayedCount < state.generalOffers.length;
        },
        incrementDisplayedCount: (state) => {
            state.displayedCount += state.needMoreDataFromAlgolia ? 15 : Math.min(15, (state.generalOffers.length - state.displayedCount));
            state.hasMore = state.needMoreDataFromAlgolia ? state.displayedCount <= state.generalOffers.length : state.displayedCount < state.generalOffers.length;
        },
        resetDisplayedCount: (state) => {
            state.displayedCount = 0;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.isError = action.payload;
        },
        setNeedMoreDataFromAlgolia: (state, action: PayloadAction<boolean>) => { // Add this new reducer
            state.needMoreDataFromAlgolia = action.payload;
        }
    },
});

export const { 
    setGeneralOffers, 
    resetGeneralOffers,
    incrementDisplayedCount,
    resetDisplayedCount,
    setLoading,
    setError,
    setNeedMoreDataFromAlgolia
} = GeneralOffersSlice.actions;
export const GeneralOffersReducer = GeneralOffersSlice.reducer;